import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/ui/Icon';


const ChatHeader = ({ conversationCount = 0, onNewConversation }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-background border-b border-border">
      <div className="max-w-4xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center shadow-sm">
              <Icon name="Sparkles" className="text-white" size={20} />
            </div>
            <div>
              <h1 className="text-xl font-semibold text-gray-900">Ranger YogiBot - AI Trip Planner</h1>
              <p className="text-sm text-gray-600">Plan now, describe your ideal adventure experience</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-2">
            {conversationCount > 0 && (
              <Button
                variant="outline"
                size="sm"
                iconName="RotateCcw"
                iconPosition="left"
                onClick={onNewConversation}
              >
                New Chat
              </Button>
            )}
            
            <div className="flex items-center space-x-2 px-3 py-2 bg-success/10 rounded-organic-sm">
              <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
              <span className="text-xs font-medium text-success">AI Online</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;